<template>
  <field :label="label">
    <input
      class="form__input"
      :type="type"
      :name="name"
      :placeholder="placeholder"
      :required="required && 'required'"
      :value="value"
      :minlength="minlength"
      :readonly="readonly"
      @input="(event) => $emit('input', event.target.value)"
    />

    <button v-if="type === 'password'" type="button" class="form__password-toggle password-toggle js-toggle-password">
      <span class="password-toggle__label password-toggle__label--show">
        {{ $t("show") }}
      </span>
      <span class="password-toggle__label password-toggle__label--hide">
        {{ $t("hide") }}
      </span>
    </button>
  </field>
</template>

<script>
import Field from "./field"

export default {
  name: "InputText",
  components: {
    Field
  },
  props: {
    type: { type: String, default: "text" },
    name: { type: String, default: null },
    label: { type: String, default: null },
    placeholder: { type: String, default: null },
    required: { type: Boolean, default: false },
    value: { type: String, default: "" },
    minlength: { type: Number, default: null },
    readonly: { type: Boolean, default: false }
  },
  i18n: {
    messages: {
      en: {
        show: "Show",
        hide: "Hide"
      },
      de: {
        show: "Anzeigen",
        hide: "Verstecken"
      },
      es: {
        hide: "Ocultar",
        show: "Mostrar"
      },
      pt: {
        hide: "Ocultar",
        show: "Mostrar"
      }
    }
  }
}
</script>
